import axios from "axios";
import Config from "../config";

const getNotification = () => {
    return axios({
        method: "post",
        url: (Config.url || '') + "/api/notification/list",
        data: {}
    });
};

export default getNotification;
